import styled, { css } from 'styled-components';
import { token } from '@zillow/constellation';

export const Dot = styled.div<{ activeType: 'forRent' | 'offMarket' }>`
  width: 12px;
  height: 12px;
  border-radius: 6px;
  background-color: ${({ activeType }) =>
    css`
      ${token('colors.' + activeType)}
    `};
  float: left;
  margin-right: 6px;
`;
